//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//

(function () {
    'use strict';
    angular.module('container.components')
        .directive('srsngUserProfileGroupManagement', srsngUserProfileGroupManagement);

    function srsngUserProfileGroupManagement(userGroupService, notificationService) {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/components/user-profile/group-management/user-profile-group-management.html',
            scope: {
                errorCallback: '='
             },
            controller: controller
        };

        function controller($scope, $rootScope, $timeout, MegaTableItemProperty, excelExportService, utilService) {

            var tableData = {
                grants: [],
                unfilteredGrants: []
            };
            var removedItems = [];


            var tableModelDefinitions = {
                displayFilter: false,
                filterAvailable: true,
                columns: [
                    {
                        key: "name",
                        order: 0,
                        title: "{{'container.userprofile.groupName' | translate}}",
                        width: 50,
                        minWidth: 50,
                        removable: false,
                        columnGroupIndex: 0,
                        visible: true,
                        dataType: 'text'
                    },
                    {
                        key: "description",
                        order: 1,
                        title: "{{'container.userprofile.groupDescription' | translate}}",
                        width: 50,
                        minWidth: 50,
                        removable: false,
                        columnGroupIndex: 0,
                        visible: true,
                        dataType: 'text'
                    }                    
                ],
                columnGroups: [{
                    scrollable: true
                }]
            };
            
            $scope.megaTableOptions = {
                data: tableData.grants,
                tableId: 'my-grants-table',
                initialize: function (mt) {
                    $scope.megatable = mt;
                },
                showFooter: false,
                showHeader: true,
                showSelectColumn: true,
                multiSelect: true,
                showSelectAll: false,
                showActionForSelectedItems: true,
                itemActionMenu: [
                    { label: "{{'container.userprofile.requestGroupMembership' | translate}}", callback: requestGrant }
                ],
                selectedItemsActionMenu: [
                    { label: "{{'container.userprofile.requestGroupMembership' | translate}}", callback: requestMultipleGrants, enabled: grantsSelected }
                ],
                tableActionMenu: [
                    { label: "container.megaTable.exportXlsx", callback: exportXlsx }
                ],
                itemsFiltered: filteredItems => {
                    tableData.grants = filteredItems;
                },
                dataSource: {
                    rowCount: function () {
                        return tableData.grants && tableData.grants.length || 0;
                    },
                    cellContent: function (columnKey, rowIndex) {

                        var entity = tableData.grants[rowIndex];
                        if (!entity) {
                            return;
                        }

                        return $('<div>' + utilService.setEmptyIfNull(entity[columnKey]) + '</div>');
                    },
                    itemAt: function (rowIndex) {
                        return tableData.grants && tableData.grants[rowIndex];
                    },
                    items: function () {
                        return tableData.grants;
                    },
                    unfilteredItems: function () {
                        return tableData.unfilteredGrants;
                    }
                },
                model: tableModelDefinitions
            };

            

            activate();

            function activate() {
                let promise = userGroupService.getUnassignedUserGroups()
                    .then(response => {
                        console.log("response: ", response);
                        tableData.grants = response.slice();
                        tableData.unfilteredGrants = tableData.grants.slice();
                        tableData.initialItems = tableData.grants.slice();
                        $timeout(() => {
                            $scope.megatable.updateData();
                        });
                    }, (error) => {
                        $rootScope.$emit('displayInnerError', "container.notification.displayError", error);
                    });                    
                $rootScope.$emit('handleBusyPromise', promise);
            }

            function requestGrant(rowIndex) {
                var group = tableData.grants[rowIndex];
                console.log("group: ", group);
                notificationService.requestGrant(group.id).then(success => {
                    $rootScope.$emit('displayInnerSuccess', "container.userprofile.displaySuccessRequestSent");
                }, error => {
                    $rootScope.$emit('displayInnerError', "container.notification.displayError", error);
                });
            }

            function requestMultipleGrants() {
                var groups = getSelectedItems();
                var ids = groups.map(a => a.id);
                console.log("selectedItems: ", groups);
                console.log("sending ids: ", ids);
                notificationService.requestMultipleGrants(ids).then(success => {
                    deselectAllItems();
                    $rootScope.$emit('displayInnerSuccess', "container.userprofile.displaySuccessRequestSent");
                }, error => {
                    $rootScope.$emit('displayInnerError', "container.notification.displayError", error);
                });
            }

            function grantsSelected() {
                var groups = getSelectedItems();
                return groups && groups.length > 0;
            }

            function getSelectedItems() {
                var selectedItems = [];
                $scope.megatable.dataSource.items().forEach(item => {
                    if (item[MegaTableItemProperty.SELECTED])
                        selectedItems.push(item);
                });
                return selectedItems;
            }

            function deselectAllItems() {
                $scope.megatable.dataSource.items().forEach(item => {
                    delete item[MegaTableItemProperty.SELECTED];
                });
            }

            function exportXlsx() {
                var data = [];
                if (tableData.grants !== undefined && tableData.grants.length > 0) {data = tableData.grants;}
                else {data = tableData.unfilteredGrants;}
                excelExportService.generateExcel(data, $scope.megatable.getColumnOrder());
            }

        }

    }

})();

